export default {
  PROCESS_WORKING: 'PROCESS_WORKING',
  INFORMATION_DARIA: 'INFORMATION_DARIA',
  CALLBACK_QUIZ: 'CALLBACK_QUIZ',
  PRESENTATION: 'PRESENTATION',
}